import { UploadInput, UploadOutput, UploaderOptions } from 'ngx-uploader';

export function formatEvent(type,url,Authorization,data): UploadInput {
    var csrfToken = Authorization;
    return {
        type,url,
        method: 'POST',
        headers: { 
            Authorization,
          'X-CSRF-Token': csrfToken
        },
        data
      };
}